import Link from "@Components/Link";

interface FormMessageProps {
  message: string;
  type: "error" | "success";
  errors?: string[];
  error?: string;
}

export const FormMessage = (props: FormMessageProps) => {
  const errorMessages = props?.errors?.length
    ? [...props.errors]
    : props?.error
    ? [props?.error]
    : [];

  const modifiedErrorMessage: string[] = [];
  errorMessages?.forEach((msg) => {
    const subMessages = msg?.includes(". ") ? msg.split(". ") : [msg]; // if there are multiple sentences, split them up
    subMessages?.forEach(
      (error) => error && modifiedErrorMessage.push(error.trim()) // the error condition prevents adding an empty string from the tail end of a split
    );
  });

  return modifiedErrorMessage?.length > 0 ? (
    <div className={`form__status form__status--${props.type}`}>
      <p className="form__message">{props.message}</p>
      <ul className="form__errors">
        {modifiedErrorMessage?.map((error: string, index: number) => (
          <li className="error" key={index}>
            <Link href="#CustomerLogin-form">
              <a className="error__link">
                <span className="error__message">{error}</span>
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};
